<template>
  <div>
    <v-card class="pa-3">
      <v-layout wrap>
        <v-flex xs6>
          <div class="primary--text">ตั้งค่าการแจ้งเตือน</div>
        </v-flex>
        <v-flex xs6 class="text-xs-right">
          <v-btn icon ripple @click="onClose">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs4>
          <div class="form-control pa-1" :class="{ 'has-error': errors.has('announce_type') }">
            <label for="announce_type" class="caption">
              ประเภทการแจ้งเตือน <span class="red--text">*</span>
            </label>
            <multiselect
              ref="announce_type"
              name="announce_type"
              v-validate="'required'"
              data-vv-as="ประเภทการแจ้งเตือน"
              v-model="input.announce_type"
              :options="announce_type_options"
              selectLabel
              :allow-empty="false"
              :searchable="false"
              open-direction="bottom"
            ></multiselect>
            <span class="text-error" v-show="errors.has('announce_type')">
              {{ errors.first('announce_type') }}
            </span>
          </div>
        </v-flex>
        <v-flex xs4>
          <div
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('affiliationMasterData') }"
          >
            <label for="affiliationMasterData" class="caption">
              สังกัด <span class="red--text">*</span>
            </label>
            <multiselect
              v-validate="'required'"
              data-vv-as="สังกัด"
              ref="affiliationMasterData"
              name="affiliationMasterData"
              v-model="input.affiliation"
              track-by="engname"
              label="engname"
              :options="affiliationOptions"
              :searchable="false"
              selectLabel
              :allow-empty="false"
              open-direction="bottom"
            ></multiselect>
            <span class="text-error" v-show="errors.has('affiliationMasterData')">
              {{ errors.first('affiliationMasterData') }}
            </span>
          </div>
        </v-flex>
        <v-flex xs4>
          <div class="form-control pa-1" :class="{ 'has-error': errors.has('division') }">
            <label for="division" class="caption"> สาขา <span class="red--text">*</span> </label>
            <multiselect
              v-validate="'required'"
              data-vv-as="สาขา"
              ref="division"
              name="division"
              v-model="input.division"
              track-by="engname"
              label="engname"
              :options="divisionOptions"
              :searchable="false"
              selectLabel
              :allow-empty="false"
              open-direction="bottom"
            ></multiselect>
            <span class="text-error" v-show="errors.has('division')">
              {{ errors.first('division') }}
            </span>
          </div>
        </v-flex>
        <v-flex xs4>
          <div
            class="form-control pa-1"
            :class="{ 'has-error': !input.start_date && errors.has('start_date') }"
          >
            <label for="start_date" class="caption">
              Start Date <span class="red--text">*</span>
            </label>
            <div class="d-flex">
              <DatepickerCustomDialog v-model="input.start_date" :allowed-dates="allowedDates">
                <template v-slot="{ computedDate }">
                  <input
                    v-validate="'required'"
                    data-vv-as="Start Date"
                    ref="start_date"
                    name="start_date"
                    type="text"
                    placeholder="DD/MM/YYYY"
                    readonly
                    :value="computedDate"
                    style="color: #000 !important"
                    class="ma-0"
                  />
                  <span class="text-error" v-show="!input.start_date && errors.has('start_date')">
                    {{ errors.first('start_date') }}
                  </span>
                </template>
              </DatepickerCustomDialog>
              <v-btn v-if="input.start_date" icon ripple @click="input.start_date = undefined">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
          </div>
        </v-flex>
        <v-flex xs4>
          <div
            class="form-control pa-1"
            :class="{ 'has-error': !input.end_date && errors.has('end_date') }"
          >
            <label for="end_date" class="caption">
              End Date <span class="red--text">*</span>
            </label>
            <div class="d-flex">
              <DatepickerCustomDialog v-model="input.end_date" :allowed-dates="allowedDates">
                <template v-slot="{ computedDate }">
                  <input
                    v-validate="'required'"
                    data-vv-as="End Date"
                    ref="end_date"
                    name="end_date"
                    type="text"
                    placeholder="DD/MM/YYYY"
                    readonly
                    :value="computedDate"
                    style="color: #000 !important"
                    class="ma-0"
                  />
                  <span class="text-error" v-show="!input.end_date && errors.has('end_date')">
                    {{ errors.first('end_date') }}
                  </span>
                </template>
              </DatepickerCustomDialog>
              <v-btn v-if="input.end_date" icon ripple @click="input.end_date = undefined">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
          </div>
        </v-flex>
        <v-flex xs4>
          <div class="form-control pa-1" :class="{ 'has-error': errors.has('department') }">
            <label for="department" class="caption"> แผนก <span class="red--text">*</span> </label>
            <multiselect
              v-validate="'required'"
              data-vv-as="แผนก"
              ref="department"
              name="department"
              v-model="input.department"
              track-by="engname"
              label="engname"
              :options="departmentOptions"
              :searchable="false"
              selectLabel
              selectedLabel
              :allow-empty="false"
              deselect-label
              open-direction="bottom"
            ></multiselect>
            <span class="text-error" v-show="errors.has('department')">
              {{ errors.first('department') }}
            </span>
          </div>
        </v-flex>
      </v-layout>
      <v-divider class="mb-4"></v-divider>
      <div>
        <div class="primary--text mb-2">Send Message(s):</div>
        <intent-group
          :key="keymessage"
          v-model="input.messages"
          :hasAlternative="false"
          :maxIntent="1"
          :availableBubbles="['text', 'button', 'image', 'generic', 'line_flex', 'line_imagemap']"
        ></intent-group>
      </div>
      <div class="text-xs-center mt-3">
        <v-btn @click="onClose" outline color="grey">cancel</v-btn>
        <v-btn :loading="saveloading" @click="onSave" depressed color="primary">save</v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import hopinnHrApi from '@/api/hopinn-hr'
import moment from 'moment'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import IntentGroup from '@/components/view/intent/IntentGroup'

export default {
  props: ['value', 'divisionMasterData', 'departmentMasterData', 'affiliationMasterData'],
  components: {
    Multiselect,
    DatepickerCustomDialog,
    IntentGroup
  },
  data() {
    return {
      keymessage: 0,
      saveloading: false,
      input: {
        announce_type: '',
        division: '',
        affiliation: '',
        department: '',
        start_date: '',
        end_date: '',
        messages: [[]]
      },
      announce_type_options: [
        'วันเกิด',
        'พนักงานใหม่',
        'แจ้งเลื่อนขั้น',
        'แจ้งโยกย้ายสถานที่ทำงาน'
      ],
      isEdit: false
    }
  },
  mounted() {
    if (this.value) {
      this.isEdit = true
      this.input.announce_type = this.value.announce_type
      this.input.start_date = this.value.start_date
      this.input.end_date = this.value.end_date
      this.input.messages = JSON.parse(this.value.a_val)

      if (this.value.division) {
        this.input.division = this.divisionMasterData.find((el) => {
          return el.engname == this.value.division
        })
      }
      if (this.value.affiliation) {
        this.input.affiliation = this.affiliationMasterData.find((el) => {
          return el.engname == this.value.affiliation
        })
      }
      if (this.value.department) {
        this.input.department = this.departmentMasterData.find((el) => {
          return el.engname == this.value.department
        })
      }
      this.keymessage++
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    divisionOptions() {
      let divisionData = this.divisionMasterData
      const check = divisionData.find((el) => {
        return el.engname == 'All'
      })
      if (!check) {
        divisionData.unshift({
          engname: 'All',
          thname: 'All'
        })
      }
      return divisionData
    },
    affiliationOptions() {
      let affiliationData = this.affiliationMasterData
      const check = affiliationData.find((el) => {
        return el.engname == 'All'
      })
      if (!check) {
        affiliationData.unshift({
          engname: 'All',
          thname: 'All'
        })
      }
      return affiliationData
    },
    departmentOptions() {
      let departmentData = this.departmentMasterData
      const check = departmentData.find((el) => {
        return el.engname == 'All'
      })
      if (!check) {
        departmentData.unshift({
          engname: 'All',
          thname: 'All'
        })
      }
      return departmentData
    }
  },
  methods: {
    clearForm() {
      this.input = {
        announce_type: '',
        division: '',
        affiliation: '',
        department: '',
        start_date: '',
        end_date: '',
        messages: [[]]
      }
    },
    onClose() {
      this.clearForm()
      this.$emit('close')
    },
    async onSave() {
      const vm = this
      if (await vm.$validator.validate()) {
        let data = {
          pageid: vm.selectedBot.pageid,
          announce_type: vm.input.announce_type,
          division: vm.input.division.engname,
          department: vm.input.department.engname,
          affiliation: vm.input.affiliation.engname,
          start_date: moment(vm.input.start_date).format('YYYY-MM-DD'),
          end_date: moment(vm.input.end_date).format('YYYY-MM-DD'),
          a_val: JSON.stringify(vm.input.messages)
        }

        if (!vm.isEdit) {
          Object.assign(data, { active: true })
        }

        vm.saveloading = true
        try {
          let response = []
          if (!vm.isEdit) {
            response = await vm.createAnnouncement(data)
          } else {
            response = await vm.updateAnnouncement(data)
          }

          vm.saveloading = false
          if (response && response.data.responsecode == 200) {
            await this.$swal.fire({
              text: 'สำเร็จ',
              type: 'success'
            })
            await vm.clearForm()
            vm.$emit('success')
          }
        } catch (error) {
          vm.saveloading = false
          console.log(error)
        }
      }
    },
    async createAnnouncement(payload) {
      return new Promise(async (resolve) => {
        console.log('payload: ', payload)
        const response = await hopinnHrApi.createAnnouncement({ data: payload })
        resolve(response)
      })
    },
    async updateAnnouncement(payload) {
      const id = this.value.id
      return new Promise(async (resolve) => {
        const response = await hopinnHrApi.updateAnnouncement({ data: payload }, id)
        resolve(response)
      })
    },
    allowedDates(val) {
      return moment().diff(val, 'days') < 1
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/HopinnHr/AutoAnnouncementManage.vue